import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login-required-modal',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  template: `
    <h2 mat-dialog-title>Login Required</h2>
    <mat-dialog-content>
      <p>Please select your profile from the dashboard to log in first.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="goToDashboard()">Go to Dashboard</button>
    </mat-dialog-actions>
  `
})
export class LoginRequiredModalComponent {
  constructor(
    private router: Router,
    private dialogRef: MatDialogRef<LoginRequiredModalComponent>
  ) {}

  goToDashboard() {
    this.router.navigate(['/']);
    this.dialogRef.close();
  }
} 